document.addEventListener("DOMContentLoaded", function () {
    let isHasGapsData = {"dxp2800":false,"dxp4800-plus":false,"dxp6800-pro":false};
    let nowPro = 'dxp2800';
    let nas_vh = window.innerHeight;
    // gsap ScrollTrigger
    gsap.registerPlugin(ScrollTrigger);
    // 全局渐显
    function animateFrom(elem, direction) {
        direction = direction || 1;
        var x = 0,
        y = direction * 100;
        elem.style.transform = "translate(" + x + "px, " + y + "px)";
        elem.style.opacity = "0";
        gsap.fromTo(
        elem,
        { x: x, y: y, autoAlpha: 0 },
        {
            duration: 2,
            x: 0,
            y: 0,
            autoAlpha: 1,
            ease: "expo",
            overwrite: "auto",
        }
        );
    }
    function hide(elem) {
        gsap.set(elem, { autoAlpha: 0 });
    }
    gsap.utils.toArray(".gs_reveal").forEach(function (elem) {
        hide(elem); // assure that the element is hidden when scrolled into view
        ScrollTrigger.create({
        trigger: elem,
        onEnter: function () {
            animateFrom(elem);
        },
        onEnterBack: function () {
            animateFrom(elem, -1);
        },
        onLeave: function () {
            hide(elem);
        }, // assure that the element is hidden when scrolled into view
        });
    });
    // if PC and Mobile
    function isMobile() {
        return window.innerWidth <= 768;
    }
    //   NAS video全屏
    function NASVideo() {
        const NASVideo = gsap.timeline({
        scrollTrigger: {
            trigger: `.NAS_video`,
            start: `top+=${nas_vh/4}px bottom`,
            scrub: true,
            end: `${nas_vh/5*4}px`,
        },
        });
        NASVideo.to(`.NAS_video .ug-custom-video`, {
            ease: "none",
            transform: "scale(1)",
        });
        // NASVideo.to(".NAS_video .video_bg", {
        //   ease: "none",
        //   autoAlpha: 1,
        // });
        NASVideo.to(`.NAS_video .nas-video-content`, {
            ease: "none",
            autoAlpha: 1,
        });
        NASVideo.to(`.NAS_video .nas-video-bg`, {
            ease: "none",
            autoAlpha: 1,
        });
        
        // NASVideo.to(".NAS_video .video_bx", {
        //   ease: "none",
        //   autoAlpha: 1,
        // });

        gsap.timeline({
            scrollTrigger: {
                trigger: `.NAS_video`,
                start: "top top",
                pin: true,
                scrub: true,
                end: `${nas_vh}px`,
            },
        });
    }
    // function NASVideo() {
    //     const NASVideo = gsap.timeline({
    //     scrollTrigger: {
    //         trigger: ".NAS_video",
    //         start: "top top",
    //         pin: true,
    //         scrub: true,
    //         end: "+=100%",
    //     },
    //     });
    //     NASVideo.to(".NAS_video .ug-custom-video", {
    //     ease: "none",
    //     transform: "scale(1)",
    //     });
    //     // NASVideo.to(".NAS_video .video_bg", {
    //     //   ease: "none",
    //     //   autoAlpha: 1,
    //     // });
    //     NASVideo.to(".NAS_video .nas-video-content", {
    //     ease: "none",
    //     autoAlpha: 1,
    //     });
    //     // NASVideo.to(".NAS_video .video_bx", {
    //     //   ease: "none",
    //     //   autoAlpha: 1,
    //     // });
    // }
    //   隐私保护全屏
    function PrivacyProtection() {
        console.log("!!!!!!!!!");
        const PrivacyProtection = gsap.timeline({
            scrollTrigger: {
                trigger: `.NAS_KS-contentdiv-${nowPro} .NAS_PrivacyProtection`,
                start: "top top",
                pin: true,
                scrub: true,
                end: "+=100%",
            },
        });
        PrivacyProtection.to(`.NAS_KS-contentdiv-${nowPro} .NAS_PrivacyProtection .top_img`, {
            ease: "none",
            transform: "translateY(0) scale(1)",
        });
        PrivacyProtection.to(`.NAS_KS-contentdiv-${nowPro} .NAS_PrivacyProtection .anquan_logo`, {
            ease: "none",
            autoAlpha: 1,
        });
        PrivacyProtection.to(`.NAS_KS-contentdiv-${nowPro} .NAS_PrivacyProtection .text`, {
            ease: "none",
            autoAlpha: 1,
        });
        PrivacyProtection.to(`.NAS_KS-contentdiv-${nowPro} .NAS_PrivacyProtection .bottom_list`, {
            ease: "none",
            autoAlpha: 1,
        });
    }

    //
    function nasDDR5Animation() {
        gsap.timeline({
            scrollTrigger: {
                trigger: `.NAS_KS-contentdiv-${nowPro} .jp-nas-ddr5-contentr`,
                start: "bottom bottom",
                scrub: true,
                end: "+=100%",
                onEnter:()=>{
                    document.querySelector(`.NAS_KS-contentdiv-${nowPro} .jp-nas-ddr5-contentr`).querySelectorAll('.jp-nas-ddr5-contentr-div').forEach((a_item,a_key)=>{
                        a_item.classList.add('active');
                    });
                }
            }
        });
    }

    //  jp-nas-multiple
    function switchContFn() {
        let multipleSwiper = ''
        if(document.querySelector(`.NAS_KS-contentdiv-${nowPro} .jp-nas-multiple-control-swiper`)){
            multipleSwiper = new Swiper(`.NAS_KS-contentdiv-${nowPro} .jp-nas-multiple-control-swiper`, {
                slidesPerView: 'auto',
                resizeObserver:true,
                spaceBetween: 14,
                breakpoints: {
                    // when window width is >= 500px
                    500: {
                        spaceBetween: 34
                    },
                    // when window width is >= 768px
                    768: {
                        spaceBetween: 50
                    }
                }
            });
        }
        let controlsParent = document.querySelector(`.NAS_KS-contentdiv-${nowPro}`).querySelectorAll('.jp-nas-multiple');
        controlsParent.forEach((a_item, a_key)=>{
            let controls = a_item.querySelectorAll('.jp-nas-multiple-control');
            controls.forEach((control) => {
                control.addEventListener('click', function () {
                    let index = this.getAttribute('data-index');
                    controls.forEach((control) => {
                        control.classList.remove('active');
                    });
                    this.classList.add('active');
                    a_item.querySelectorAll('.jp-nas-multiple-textdiv').forEach((textdiv) => {
                        textdiv.classList.remove('active');
                    });
                    
                    a_item.querySelectorAll('.jp-nas-multiple-imgdiv').forEach((imgdiv) => {
                        imgdiv.classList.remove('active');
                    });
                    a_item.querySelector(`.jp-nas-multiple-textdiv${index}`).classList.add('active');
                    a_item.querySelector(`.jp-nas-multiple-imgdiv${index}`).classList.add('active');

                    if(document.querySelector(`.NAS_KS-contentdiv-${nowPro} .jp-nas-multiple-control-swiper`)){
                        let multipleSwiperIndex = parseInt(index) - 1;
                        multipleSwiper.slideTo(multipleSwiperIndex);
                    }
                    
                });
            });
        });

        
    }
    function nasMultipleAnimation() {
        gsap.timeline({
            scrollTrigger: {
                trigger: `.NAS_KS-contentdiv-${nowPro} .jp-nas-multiple-imgcontdiv`,
                start: "bottom bottom",
                scrub: true,
                end: "+=100%",
                onEnter:()=>{
                    document.querySelector(`.NAS_KS-contentdiv-${nowPro} .jp-nas-multiple-imgcontdiv`)?.classList.add('toanimate');
                }
            }
        });
    }
    // jp-nas-multiple end

    function nasInitFn(){
        if(!document.querySelectorAll(`.NAS_KS-contentdiv-${nowPro}`).length>0){
            return false;
        }
        if (!isMobile()) {
            NASVideo();
            PrivacyProtection();
        }
        nasDDR5Animation();
        switchContFn();
        nasMultipleAnimation();
        isHasGapsData[nowPro] = true;
    }
    nasInitFn();
    


    function proModelChangeFn(){
        document.querySelectorAll('.NAS_product-tab-itemFn').forEach(proModel => {
            proModel.addEventListener('click', function(){
                if(this.classList.contains('active')){
                    return false;
                }
                document.querySelectorAll('.NAS_product-tab-itemFn.active').forEach(item => {
                    item.classList.remove('active');
                });
                nowPro = this.getAttribute('data-pro');
                document.querySelectorAll(`.NAS_product-tab-itemFn[data-pro="${nowPro}"]`).forEach(item => {
                    item.classList.add('active');
                });

                document.querySelectorAll('.NAS_KS-contentdiv').forEach(proModel => {
                    proModel.classList.remove('active');
                });
                document.querySelector(`.NAS_KS-contentdiv-${nowPro}`).classList.add('active');
                setTimeout(()=>{
                    proModelChangeAfterFn();
                },10);
            });
        });
    }
    function proModelChangeAfterFn(){
        if(!isHasGapsData[nowPro]){
            nasInitFn();
        }
        setTimeout(()=>{
            let scrolljl = document.documentElement.scrollTop || document.body.scrollTop;
            let content = document.querySelector('.NAS_product-tabdiv .content');
            let contentScrollJL = 0;
            contentScrollJL = content.getBoundingClientRect().top + scrolljl - 20;
            window.scrollTo({
                top: contentScrollJL,
                behavior: "smooth"
            });
            
            setTimeout(()=>{
                // 确保所有 ScrollTrigger 的起点和终点在窗口尺寸变化时正确刷新
                ScrollTrigger.refresh(); 
            },700);
        },10);
    }
    proModelChangeFn();

    //tab切换 悬浮
    function proModelFixedFn(){
        gsap.timeline({
            scrollTrigger: {
                trigger: `.NAS_product-tabdiv`,
                start: `top top`,
                scrub: true,
                end: () => `+=${document.querySelector('.NAS_product-tabdiv').offsetHeight}`,
                onEnterBack: function(){
                    document.querySelector('.NAS_product-tabFixedDiv')?.classList.remove('toNasFixed');
                },
                onLeave: function(){
                    document.querySelector('.NAS_product-tabFixedDiv')?.classList.add('toNasFixed');
                }
            },
        });

        gsap.timeline({
            scrollTrigger: {
                trigger: `.ug-product-comparediv`,
                start: `top top`,
                scrub: true,
                end: () => `+=${document.querySelector('.ug-product-comparediv').offsetHeight}`,
                onEnter: function(){
                    document.querySelector('.NAS_product-tabFixedDiv')?.classList.remove('toNasFixed');
                },
                onLeaveBack: function(){
                    document.querySelector('.NAS_product-tabFixedDiv')?.classList.add('toNasFixed');
                },
                onLeave: function(){
                    document.querySelector('.NAS_product-tabFixedDiv')?.classList.add('toNasFixed');
                },
                onEnterBack: function(){
                    document.querySelector('.NAS_product-tabFixedDiv')?.classList.remove('toNasFixed');
                }
            },
        });
    }
    proModelFixedFn();
    //tab切换 悬浮end
})